import { render, staticRenderFns } from "./LayingBirdsIcon.vue?vue&type=template&id=85565c50"
import script from "./LayingBirdsIcon.vue?vue&type=script&lang=js"
export * from "./LayingBirdsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports